module.exports = __webpack_public_path__ + "static/media/fz_verifydialoglocal_pt_PT.ade1ec5e.png";